import { useEffect, useRef, useState } from 'react';
import { Loader, Stack, Text } from '@mantine/core';
import useApi from '../../hooks/useApi';
import { findV2CampaignProspects } from '../../services/api';

const NARRATION = [
  'Looking for the right people…',
  'Reading their profiles…',
  'Almost there…',
];

export default function FindingScreen({
  campaignId,
  onFound,
  onError,
  mode = '',
}) {
  const api = useApi();
  const [lineIndex, setLineIndex] = useState(0);
  const startedRef = useRef(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setLineIndex((i) => (i + 1) % NARRATION.length);
    }, 2500);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    findV2CampaignProspects(api, campaignId, mode)
      .then((response) => onFound(response))
      .catch((err) => onError(err.response?.data?.error || err.message || 'Something went wrong'));
  }, [api, campaignId, onFound, onError, mode]);

  return (
    <Stack align="center" justify="center" gap="lg" py={80}>
      <Loader color="sage" size="xl" />
      <Text size="lg" ta="center" style={{ color: 'var(--aviary-ink)', minHeight: 28 }}>
        {NARRATION[lineIndex]}
      </Text>
    </Stack>
  );
}
